import { createContext } from "react";

export const ConfigInvContext = createContext({
  configInv: { startDate: null, endDate: null },
  setConfigInv: () => {},
});
